import { ConfigProvider } from "melco-ui";
import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { DataMappingAttribute } from "../../hooks/inputFormats/useDataMappings";
import { useFontCollectionsDropdownData } from "../../hooks/libraries/fontCollections/useFontCollectionsDropdown";

type SelectFontCollectionProps = {
  attribute: DataMappingAttribute;
};

export const SelectFontCollection: React.FC<SelectFontCollectionProps> = ({
  attribute,
}) => {
  const { t } = useTranslation();

  const { isLoading, isFetching, data, isPreviousData } =
    useFontCollectionsDropdownData();

  const fontCollectionOptions = (data ?? []).map((o) => ({
    value: o.id ?? "",
    label: o.name ?? "",
  }));

  return (
    <ConfigProvider renderEmpty={() => <>{t("font_collections_list.empty")}</>}>
      <SelectField
        name={`${attribute}.fontCollection`}
        label={t("dataMappings.form.label.fontCollection")}
        loading={isPreviousData ? isFetching : isLoading}
        style={{ width: "100%" }}
        options={fontCollectionOptions}
        showSearch
        optionFilterProp="label"
        filterOption
        allowClear
        placeholder={t("global.fallback.none")}
        info={t("libraries.font_collections.detail.form.embroideryWarning")}
      />
    </ConfigProvider>
  );
};
